import React from 'react';
import Layout from '../../components/layout';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import { PAGE_TITLE, RESPONSIVENESS_BREAKPOINT_VALUE } from '../../constants/enum';
import Page from '../../components/Page';
import Seo from '../../components/seo';
import { PATH_PAGE } from '../../routes/paths';
import CheckMark from '../../images/icons/customSvg/CheckMark';
import PrimaryButton from '../../components/ui/buttons/PrimaryButton';
import MSText from '../../components/ui/typography/MSText';
import EditImportedInvoiceForm from '../../components/importedInvoices/EditImportedInvoiceForm';
import { useSelector } from 'react-redux';
import useWindowDimensions from '../../hooks/useWindowDimensions';

export default function EditImportingInvoice() {
  const { width } = useWindowDimensions();

  const isLoading = useSelector((state) => state.importingInvoiceReducer?.loading);

  return (
    <Layout>
      <Page title="Edit Importing Invoice">
        <HeaderBreadcrumbs
          subtitleClass={width < RESPONSIVENESS_BREAKPOINT_VALUE.MEDIUM ? 'mb-2' : 'mb-2'}
          titleContainerClass={{
            flexDirection: ['column', 'row', 'row'],
            alignItems: ['left', 'center', 'center'],
            width: '100%'
          }}
          sx={{ height: ['100%', '56px', '56px'], display: 'flex', alignItems: 'center' }}
          heading={PAGE_TITLE.EDIT_IMPORTING_INVOICE}
          links={
            width > RESPONSIVENESS_BREAKPOINT_VALUE.MEDIUM
              ? [{ name: PAGE_TITLE.GET_PAID, href: PATH_PAGE.pay }, { name: PAGE_TITLE.EDIT_IMPORTING_INVOICE }]
              : [{ name: '' }]
          }
          action={
            <div className="flex flex-row gap-2">
              <PrimaryButton
                id="edit-invoice-save-btn"
                isLoading={isLoading}
                form="edit-imported-invoice-form"
                buttonType="submit"
                caption={
                  <div className="flex gap-2 items-center">
                    <div className="w-6">
                      <CheckMark />
                    </div>
                    <MSText textColor="text-white" fontWeight="text-bold" title="Save" />
                  </div>
                }
                fontWeight="text-bold"
                type="small"
              />
            </div>
          }
        />
        <EditImportedInvoiceForm />
      </Page>
    </Layout>
  );
}

export const Head = () => (
  <Seo title="View Your Invoice" description="Create Your invoice by Register on our website" />
);
